import api from './api-service';

class repository {
  fetchCoupons = id => {
    return new Promise((resolve, reject) => {
      api
        .coupons(id)
        .then(value => {
          const coupon = value.data.data;
          resolve(coupon);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  validateCoupon = (id, couponCode, plateNumber) => {
    return new Promise((resolve, reject) => {
      api
        .validateCoupon(id, couponCode, plateNumber)
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  redeemCoupon = (id, couponCode, plateNumber, email, mobile) => {
    return new Promise((resolve, reject) => {
      api
        .couponRedeem(id, couponCode, plateNumber, email, mobile)
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  };
}

export default new repository();
